import { Formik, Field, Form, ErrorMessage } from "formik";
import { TextField } from "@mui/material";
import { Input, Select } from "app/components";
import { twMerge } from "tailwind-merge";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ptBR } from "@mui/x-date-pickers/locales";
import "date-fns";
import InputMask from 'react-input-mask'
const FormikField = ({
  variant,
  name,
  placeholder,
  label,
  options,
  disabled,
  className,
  values,
  handleChange,
  setFieldValue,
  touched,
  errors
}) => {
  //   const classes = useStyles();
  //   const [open, setOpen] = useState(false);

  const togglePopup = async () => {
    setOpen((open) => !open);
  };

  return (
    <div>
      {variant == "datepicker" ? (
        <div
          className={twMerge(
            "tw-relative tw-mb-6 tw-w-full tw-flex tw-flex-col",
            className
          )}
        >
          {/* {field.onChange ? true : false} */}
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale="pt-br"
            localeText={
              ptBR.components.MuiLocalizationProvider.defaultProps.localeText
            }
          >
            <Input.Label text={label}></Input.Label>
            <Field name={name}>
              {({ field, form }) => (
                <Input.DatePicker
                  className="w-full"
                  format="DD/MM/YYYY"
                  value={field.value || null}
                  onChange={(date) => form.setFieldValue(name, date)}
                  slotProps={{
                    textField: {
                      error: (form.touched[name] || form.submitCount > 0) && Boolean(form.errors[name]),
                      helperText: (form.touched[name] || form.submitCount > 0) && form.errors[name],
                      size: 'small'
                    }
                  }}
                />
              )}
            </Field>
          </LocalizationProvider>
          {(touched[name] || errors[name]) && errors[name] && <Input.Error text={errors[name]} />}

          {/* {JSON.stringify( values)} */}
        </div>
      ) : (
        <Field name={name} onChange={handleChange}>
            {({
            field, // { name, value, onChange, onBlur }
            form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
            meta,
          }) => (
            <>
              {(!variant || variant == "input") && (
                <div
                  className={twMerge(
                    "tw-relative tw-mb-6 tw-w-full tw-flex tw-flex-col",
                    className
                  )}
                >
                  <Input.Label text={label}></Input.Label>
                  <Input.Element
                    disabled={disabled}
                    placeholder={placeholder || ""}
                    inputProps={field}
                    error={(meta.touched || form.submitCount > 0) && meta.error}
                    {...field}
                  ></Input.Element>
                  {(meta.touched || form.submitCount > 0) && meta.error && (
                    <div className="tw-absolute -tw-bottom-5 error tw-text-sm tw-text-primary">
                      {meta.error}
                    </div>
                  )}
                  {/* {JSON.stringify( values)} */}
                </div>
              )}
              {variant == "select" && (
                <div
                  className={twMerge(
                    "tw-relative tw-mb-6 tw-w-full tw-flex tw-flex-col",
                    className
                  )}
                >
                  <Input.Label text={label}></Input.Label>
                  <Select.Element
                    disabled={disabled}
                    placeholder={placeholder || ""}
                    inputProps={field}
                    options={options}
                    error={(meta.touched || form.submitCount > 0) && meta.error}
                    {...field}
                    onChange={handleChange}
                  ></Select.Element>
                  {(meta.touched || form.submitCount > 0) && meta.error && (
                    <div className="tw-absolute -tw-bottom-5 error tw-text-sm tw-text-primary">
                      {meta.error}
                    </div>
                  )}

                  {/* {JSON.stringify( values)} */}
                </div>
              )}
              {variant == "mask" && (
                <div
                  className={twMerge(
                    "tw-relative tw-mb-6 tw-w-full tw-flex tw-flex-col",
                    className
                  )}
                >
                  <Input.Label text={label}></Input.Label>
                  <InputMask
                    className='px-3 tw-py-[7px] tw-rounded-[4px] tw-border tw-border-solid tw-border-[#c4c4c4] hover:tw-border-[#000000de] active:tw-border-3 active:tw-border-[#1976d2]'
                    mask={
                      values[name] && values[name].replace(/\D/g, "").length > 11
                        ? "99.999.999/9999-99" // CNPJ
                        : "999.999.999-999" // CPF
                    }
                    maskChar=""
                    value={values[name]}
                    onChange={(e) => {
                      console.log(e)
                      field.onChange(e);
                      handleChange(e); // Chamada extra para garantir sincronização
                    }}
                    {...field}
                    id={name}
                    disabled={disabled}
                    placeholder={placeholder || ""}
                  />
                  {(meta.touched || form.submitCount > 0) && meta.error && (
                    <div className="tw-absolute -tw-bottom-5 error tw-text-sm tw-text-primary">
                      {meta.error}
                    </div>
                  )}

                  {/* {JSON.stringify( values)} */}
                </div>
              )}
            </>
          )}
        </Field>
      )}
    </div>
  );
};

// let style = {
//   padding: '4px 0 5px';'
//   border: 0;
//   box-sizing: content-box;
//   background: none;
//   height: 1.4375em;
//   margin: 0;
//   -webkit-tap-highlight-color: transparent;
//   display: block;
//   min-width: 0;
//   width: 100%;
//   -webkit-animation-name: mui-auto-fill-cancel;
//   animation-name: mui-auto-fill-cancel;
//   -webkit-animation-duration: 10ms;
//   animation-duration: 10ms;
//   padding-top: 1px;
//   padding: 16.5px 14px;
//   padding: 8.5px 14px;
// }

export { FormikField };
